import { defineStore } from "pinia"
import config from "@/config.js"
import { fetchApi, fetchApiJson } from "@/services/repowerAPIService.js"
import { setPlausibleUserSegment } from "@/services/plausibleService.js"
import useUserStore from "@/stores/userStore"
import * as Sentry from "@sentry/browser"

export default defineStore("sessionStore", {
  state: () => ({
    unknown: true,
    loading: false,
    loadingFailed: false,
    isAuthenticated: false,
    csrfToken: null,
  }),
  actions: {
    setAuthenticated(isAuthenticated) {
      this.isAuthenticated = Boolean(isAuthenticated)
      const userStore = useUserStore()
      if (this.isAuthenticated) {
        setPlausibleUserSegment(userStore.analyticsSegment)
        Sentry.setUser({ email: userStore.email })
      } else {
        setPlausibleUserSegment("unauthenticated")
        Sentry.setUser(null)
      }
    },
    getSession(onAuthenticated, onUnauthenticated, onFail) {
      this.loading = true
      this.loadingFailed = false
      fetchApiJson("/users/session/", {
        credentials: config?.credentials,
      })
        .then((data) => {
          if (data.isAuthenticated && data.user) {
            const userStore = useUserStore()
            userStore.setUser(
              data.user.user_id,
              data.user.user_full_name,
              data.user.user_email,
              data.user.user_flags,
              data.user.analytics_segment,
              data.user.notifications_seen_until,
            )
          }
          this.setAuthenticated(data.isAuthenticated)
          if (data.isAuthenticated && onAuthenticated) {
            onAuthenticated(data)
          } else if (onUnauthenticated) {
            onUnauthenticated()
          }
        })
        .catch((error) => {
          this.setAuthenticated(false)
          if (error.code !== 403) {
            console.error(
              `Unable to fetch session, authentication revoked (code: ${error.code})`,
            )
            this.loadingFailed = true
            if (onFail) onFail(error)
          } else {
            if (onUnauthenticated) onUnauthenticated()
          }
        })
        .finally(() => {
          this.loading = false
          this.unknown = false
        })
    },
    requestCsrfToken() {
      fetchApi("/users/csrf/", {
        credentials: config?.credentials,
      })
        .then((res) => {
          this.csrfToken = res.headers.get("X-CSRFToken")
        })
        .catch((error) => {
          console.error(`Unable to fetch CSRF token (code: ${error.code})`)
        })
    },
  },
})
